class ProductGridToggles extends HTMLElement {
  constructor() {
    super();
    this.gridSizeToggles = document.querySelectorAll("[data-grid-toggle]");
    this.productGrid = document.querySelector("#CollectionLoop");
    this.imageToggleButton = document.querySelector("[data-grid-image-toggle]");

    this.gridSizeToggles.forEach((toggle) =>
      toggle.addEventListener("click", (e) => {
        const button = e.target;
        let size = button.dataset.gridToggle;
        if (!size) size = button.closest("button").dataset.gridToggle;
        this.setGridSize(size);
      })
    );
    this.imageToggleButton.addEventListener("click", () => {
      this.setImagePreference();
    });

    const storedGridSize = localStorage.getItem("collection-grid-size");
    if (storedGridSize) this.setGridSize(storedGridSize);
    else this.setGridSize("medium");
    const storedImagePreference = localStorage.getItem("collection-image-preference");
    if (storedImagePreference) this.setImagePreference(storedImagePreference);
    else this.setImagePreference("featured");
  }

  setGridSize(size) {
    this.productGrid.classList.remove("product-grid--small", "product-grid--medium", "product-grid--large");
    this.productGrid.classList.add(`product-grid--${size}`);
    this.gridSizeToggles.forEach((b) => b.classList.remove("active"));
    document.querySelector(`button[data-grid-toggle="${size}"]`).classList.add("active");
    localStorage.setItem("collection-grid-size", size);
  }

  setImagePreference(force) {
    let isEnabled = this.productGrid.classList.contains("product-grid--second-images");
    if (force) isEnabled = force === "model" ? false : true;
    this.productGrid.classList.toggle("product-grid--second-images", !isEnabled);
    this.imageToggleButton.classList.toggle("active", !isEnabled);
    localStorage.setItem("collection-image-preference", isEnabled ? "featured" : "model");
  }
}

if (!customElements.get("product-grid-toggles")) customElements.define("product-grid-toggles", ProductGridToggles);
